import {
  createOhouseFooterLinkSchema,
  OhouseFooter,
} from '@bucketplace/design-system/bds';
import { useLocation } from '@bucketplace/next-extra';
import styled from '@emotion/styled';
import React, { type MutableRefObject } from 'react';
import { DOMAINS, OHS_HOST } from '@/common';
import { getQuery, isInApp } from '@/utils';

interface FooterContainerProps {
  footerRef: MutableRefObject<HTMLDivElement | null>;
}

export const FooterContainer = ({
  footerRef,
}: FooterContainerProps): React.ReactElement | null => {
  const location = useLocation();

  if (isInApp(getQuery(location.search))) {
    return null;
  }
  return (
    <Container ref={footerRef}>
      <OhouseFooter
        ohouseFooterLinks={createOhouseFooterLinkSchema({
          ohs: OHS_HOST,
          pro: DOMAINS.O2O_PARTNER,
        })}
      />
    </Container>
  );
};

const Container = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
`;
